'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _components = require('components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
// https://www.reddit.com/r/reactjs/comments/4qt72d/ask_reactjs_redux_store_databases/
var Module1Res1 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Res1, _Component);

  function Module1Res1() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Res1);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Res1.__proto__ || (0, _getPrototypeOf2.default)(Module1Res1)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currPage: 0,
      title: 'Putting the five food groups all together'
    }, _this.handleClickNext = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage + 1;

      _this.setState(obj);
    }, _this.handleClickPrev = function () {
      var obj = _this.state;
      obj.currPage = _this.state.currPage - 1;

      _this.setState(obj);
    }, _this.handleOnClick = function (item, event) {
      event.preventDefault();
      var obj = _this.state;
      obj.currPage = item;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   *  User clicks on Next
   *  Increments the Page number and changes panel
   */


  /**
   *  User clicks on Previous
   *  Decrements the Page number and changes panel
   */


  /*
   * Quick link at the top to change the current page
   * to the selected page
   */


  (0, _createClass3.default)(Module1Res1, [{
    key: 'render',
    value: function render() {
      var currPage = this.state.currPage;

      var styles = require('../Resources.scss');
      var year2 = require('./Assets/2to3.png');
      var year4 = require('./Assets/4to8.png');
      var year9 = require('./Assets/9to13.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                'Module 1'
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(
              'p',
              null,
              'These images show how the same meal could be adapted to suit the requirements for children of different ages.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The five food groups are represented:'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Lean meat (chicken meatballs), vegetables (broccoli, peas, corn and capsicum in addition to carrot and zucchini in the meatballs), grains (wholemeal flatbread), fruit (strawberries and grapes) and dairy (low fat yoghurt). Water is pictured alongside the meal as the ideal drink.'
            ),
            _react2.default.createElement(_components.PercentRequirementsMetTable, { ageBracket: '2 - 3 years', yearImage: year2, vegetablePercent: '60',
              meatPercent: '75', grainPercent: '15', dairyPercent: '30', fruitPercent: '50' }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.PercentRequirementsMetTable, { ageBracket: '4 - 8 years', yearImage: year4, vegetablePercent: '60',
              meatPercent: '75', grainPercent: '25', dairyPercent: '30', fruitPercent: '60' }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.PercentRequirementsMetTable, { ageBracket: '9 - 13 years', yearImage: year9, vegetablePercent: '60',
              meatPercent: '75', grainPercent: '20', dairyPercent: '30', fruitPercent: '50' })
          ),
          _react2.default.createElement('div', { className: styles.spacer20 })
        )
      );
    }
  }]);
  return Module1Res1;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
/* eslint-enable */

exports.default = Module1Res1;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/1/Res1.js
// module id = 1234
// module chunks = 0